export default theme => ({
  root: {
    padding: '10px 15px !important',
    maxWidth: '1280px',
    margin: '0 auto',
  }
});
